<app-loader-indicator></app-loader-indicator>
<div class="full-page-container">
  <div class="congratulation-box">
    <div class="text-box">
      <mat-icon>done_outline</mat-icon><span class="margin-left-10">Course has been completed</span>
    </div>
  </div>
</div>
